<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Çalışma Grubu</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Çalışma Grubu" v-model="value.Name">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Çalışma Grubu Kodu</label>
            <v-validator :errors="errors" parameter="Code" :watch="value.Code">
                <input type="text" class="form-control" placeholder="Çalışma Grubu Kodu" v-model="value.Code">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.IsVisibleFromVehicleInventory">Araç Envanter Sayfasında Gösterim</b-form-checkbox>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.IsOwnFirm"><strong>{{companyName}}</strong> Firmasına Ait</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import Auth from '@/utilities/auth'
import VValidator from '@/components/VValidator.vue'
export default{
    components:{
        BFormCheckbox,
        VValidator
    },
    props:{
        value:Object,
        errors:Object
    },
    computed:{
        companyName(){
            return Auth.companyName
        }
    }
}
</script>

<style >
</style>